var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['underscore'], function(_) {
  var LocalStorage;
  return LocalStorage = (function() {

    function LocalStorage(namespace, id) {
      if (namespace == null) {
        namespace = '';
      }
      if (id == null) {
        id = 0;
      }
      this.namespace = "reconciliation" + namespace;
      this.localStorageKey = "" + this.namespace + "_" + id;
      this.maxStored = 100;
      this.maxCleared = this.maxStored / 2;
    }

    /*
    Save an item to local storage.
    
    * If number of reconciliation storage keys equals @maxStored, delete oldest n rec keys
    * If local storage is full, clear the oldest n rec keys, then retry.
    */


    LocalStorage.prototype.save = function(items) {
      var clearReconciliationStorage, reconciliationKeys, regex, setReconciliationStorage,
        _this = this;
      regex = new RegExp("^" + this.namespace + "_");
      reconciliationKeys = _.filter(Object.keys(localStorage), function(key) {
        return regex.test(key) && key !== _this.localStorageKey;
      });
      if (reconciliationKeys == null) {
        reconciliationKeys = [];
      }
      setReconciliationStorage = function() {
        return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.setItem(_this.localStorageKey, JSON.stringify(items)) : void 0;
      };
      clearReconciliationStorage = function() {
        var key, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = reconciliationKeys.length; _i < _len; _i++) {
          key = reconciliationKeys[_i];
          if (__indexOf.call(_.first(reconciliationKeys, _this.maxCleared), key) >= 0) {
            _results.push(_this.remove(key));
          }
        }
        return _results;
      };
      if (reconciliationKeys.length >= this.maxStored) {
        clearReconciliationStorage();
      }
      try {
        return setReconciliationStorage();
      } catch (error) {
        clearReconciliationStorage();
        return setReconciliationStorage();
      }
    };

    LocalStorage.prototype.load = function() {
      var items;
      items = JSON.parse(typeof localStorage !== "undefined" && localStorage !== null ? localStorage.getItem(this.localStorageKey) : void 0);
      return items != null ? items : items = {};
    };

    LocalStorage.prototype.update = function(key, val) {
      var items;
      items = this.load();
      items[key] = val;
      return this.save(items);
    };

    LocalStorage.prototype.remove = function(key) {
      if (key == null) {
        key = this.localStorageKey;
      }
      return typeof localStorage !== "undefined" && localStorage !== null ? localStorage.removeItem(key) : void 0;
    };

    return LocalStorage;

  })();
});
